'use client'

import { Grid2 as Grid, Typography } from '@mui/material'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

// Utils
import ToPersianNumber from '@/utils/to-persian-number'

const DownloadedAtom = () => {
	// Varaibles
	const { t } = useTranslation()

	return (
		<Grid
			container
			direction="row-reverse"
			alignContent="center"
			width={{ xs: 188, md: 284 }}
			height={{ xs: 96, md: 144 }}
			p={2}
			color="common.white"
			bgcolor="primary.dark"
			borderRadius={2}
			sx={{ borderBottomLeftRadius: 0 }}
		>
			<Grid size="auto">
				<Typography variant="body1" fontSize={{ xs: 19, md: 32 }} fontWeight={700} lineHeight={1.5} letterSpacing={{ xs: -0.5, md: -2 }}>
					{ToPersianNumber('500,000+')}
				</Typography>
			</Grid>

			<Grid size={12}>
				<Typography variant="body1" fontSize={{ xs: 14, md: 24 }} fontWeight={500} lineHeight={1.5} letterSpacing={{ xs: -0.5, md: -2 }}>
					{t('common:title.installedOnAllPlatform')}
				</Typography>
			</Grid>
		</Grid>
	)
}

export default DownloadedAtom
